import { Box, TextField, Typography } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import React from "react";
import { sizes } from "../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { setPGState } from "./productGroupSetupSlice";

export default function Comments() {
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.productGroupSetup);
	const { comments } = cgState;

	function updateComment(event) {
		const comment = event.target.value;
		dispatch(setPGState("comments", comment));
	}

	return (
		<Box>
			{" "}
			{/* <Box sx={{ mt: 1, display: "flex", flexDirection: "row" }}>
				<Typography className="compHeading" sx={{fontWeight: "bold", color: "blue.main", width: "100%" }}>
				<CommentIcon sx={{ color: "blue.main", mr: 1, width: 22, transform:"translate(0px, 6px)",}} />
					Comments
				</Typography>
			</Box>{" "} */}
			<TextField className={'fullHeight'}
						overflow="scroll"
						multiline
						id="outlined-basic"
						label=""
						rows= {6}
						variant="outlined"
						sx={{
							width: 1000,
						}}
				InputProps={{ sx: { height: sizes.w150 }, autoComplete: "off" }}
				value={comments}
				onChange={updateComment}
			/>
		</Box>
	);
}
